// app埋点事件名称配置文件

const Open_Account_Applied_For = 'open_account_applied_for' //开户申请已提交
export default {
    Open_Account_Applied_For,
}
